<template>
  <div>
    <div class="tab-inner-form">
      <div>

      </div>
      <div>
        <ent-auto-select
          v-model="config.vendorId"
          :callback="()=> { handleCurrentChange(1) }" />
        <!-- <el-input
          v-model="config.vendorName"
          clearable
          placeholder="请输入企业名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input> -->
      </div>
    </div>
    <el-table
      border
      :data="list">
      <!-- <el-table-column
        width="180"
        label="检测记录唯一编号"
        prop="syscode"> </el-table-column>
      <el-table-column
        label="样品编号"
        width="80"
        prop="samplenum"></el-table-column> -->
      <el-table-column
        label="样品名称"
        min-width="120"
        prop="samplename"></el-table-column>
      <!-- <el-table-column
        label="样品种类"
        prop="sampletype"></el-table-column> -->
      <el-table-column
        label="企业名称"
        min-width="170"
        prop="prosecutedunits"></el-table-column>
      <el-table-column
        label="检测项"
        min-width="100"
        prop="testproject"></el-table-column>
      <el-table-column
        min-width="160"
        label="检测模块-方法">
        <template slot-scope="{ row }">
          {{ row.testmoudle }}-{{ row.testmethod }}
        </template>
      </el-table-column>
      <el-table-column
        min-width="60"
        label="判定值">
        <template slot-scope="{ row }">
          {{ row.symbol }}{{ row.cov }}{{ row.covunit }}
        </template>
      </el-table-column>
      <el-table-column
        label="判定标准"
        min-width="140"
        prop="standnum"></el-table-column>
      <el-table-column
        label="检测结果值"
        min-width="90"
        prop="testresult"></el-table-column>
      <el-table-column
        label="判定结果"
        min-width="90"
        prop="decisionoutcome"></el-table-column>
      <el-table-column
        label="检测人员"
        width="100"
        prop="inspector"></el-table-column>
      <!-- <el-table-column
        label="检测地点"
        width="160"
        prop="testsite"></el-table-column> -->
      <el-table-column
        label="检测时间"
        min-width="135"
        prop="testingtime">
        <template slot-scope="{ row }">
          {{ row.testingtime | dateformat() }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      slot="footer"
      background
      style="text-align:center"
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="totalNum"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EntAutoSelect from '../../../components/ent-auto-select.vue'

export default {
  name: 'ReportedTable',
  components: { EntAutoSelect },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        vendorId: null,
        statusList: [1]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getinspectiondatas', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
